import * as Sentry from "@sentry/react";
import { getApiBaseUrl } from "../utils/apiBase.js";

export let accessToken = null;

let sessionDead = false;
let refreshPromise = null;

export function isSessionDead() {
  return sessionDead;
}

export function setAccessToken(t) {
  accessToken = t;
  if (t) sessionDead = false;

  if (typeof window !== "undefined" && window.localStorage) {
    if (t) {
      window.localStorage.setItem("token", t);
    } else {
      window.localStorage.removeItem("token");
    }
  }
}

function apiBase() {
  return getApiBaseUrl().replace(/\/+$/, "");
}

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

export async function serverLogout() {
  try {
    const base = apiBase();
    const csrf = getCookie("csrf");
    await fetch(base + "/auth/logout", {
      method: "POST",
      credentials: "include",
      headers: csrf ? { "X-CSRF-Token": csrf } : {},
    });
  } catch (error) {
    console.warn("[serverLogout] Logout Fehler:", error);
  }
}

async function refreshOnce() {
  try {
    const base = apiBase();
    const csrf = getCookie("csrf");
    const res = await fetch(base + "/auth/refresh", {
      method: "POST",
      credentials: "include", // Cookies mitsenden
      headers: csrf ? { "X-CSRF-Token": csrf } : {},
    });
    if (!res.ok) {
      console.warn(
        "[silentRefresh] Refresh fehlgeschlagen:",
        res.status,
        res.statusText,
      );
      // Every failed refresh logs out, but a 401 is not reported: it just means
      // "no or expired session", e.g. every logged-out visit to the login page.
      if (res.status !== 401) {
        Sentry.captureException(
          new Error(`[silentRefresh] HTTP ${res.status}`),
        );
      }
      return await failRefresh(csrf);
    }
    const data = await res.json();
    const newToken = data && data.accessToken ? data.accessToken : null;
    setAccessToken(newToken);
    return newToken;
  } catch (error) {
    console.warn("[silentRefresh] Refresh Fehler:", error);
    Sentry.captureException(error);
    return await failRefresh(getCookie("csrf"));
  }
}

async function failRefresh(csrf) {
  setAccessToken(null);
  sessionDead = true;
  // Ohne csrf-Cookie existiert keine Server-Session, die beendet werden müsste.
  if (csrf) await serverLogout();
  return null;
}

// Parallele Aufrufer teilen sich einen Refresh. Der Refresh-Token rotiert,
// ein zweiter gleichzeitiger Refresh würde als Token-Reuse die Session widerrufen.
export function silentRefresh() {
  if (!refreshPromise) {
    refreshPromise = refreshOnce().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}
